// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  display: flex;
  justify-content: center;
  height: 100%;
}

.item {
  padding: 0.25rem;
  color: #0364B4 !important;
}

.selected {
  background-color: #0364B4;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  color: #fff !important;
  align-items: center;
}

.main-item {
  width: 2rem;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  padding: 0px 14px;
  border-right: 1px solid #DEE2E6;
  align-items: center;
}

.next-prev:hover {
  width: 2rem;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  padding: 0px 17px;
  border-right: 1px solid #DEE2E6;
  align-items: center;
}

.next-prev {
  width: 2rem;
  width: 2rem;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  padding: 0px 17px;
  border-right: 1px solid #DEE2E6;
  align-items: center;
}

.msg {
  position: fixed;
  bottom: 0.8rem;
  left: 1dvw;
  color: gray;
}

.mainSelected {
  background-color: #0364B4;
  border-radius: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/paginationcomponent/paginationcomponent.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAGA;EACI,gBAAA;EACA,yBAAA;AAAJ;;AAKA;EACI,yBAAA;EAEA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AAHJ;;AAkBA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AAfJ;;AAkBA;EACI,WAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AAfJ;;AAkBA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AAfJ;;AAkBA;EACI,yBAAA;EACA,6BAAA;AAfJ","sourcesContent":[".pagination {\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 100%;\r\n\r\n}\r\n\r\n.item {\r\n    padding: 0.25rem;\r\n    color:#0364B4 !important;\r\n    //font-weight: bolder;\r\n    //font-size: 1rem;\r\n}\r\n\r\n.selected {\r\n    background-color: #0364B4;\r\n    //border-radius: 50%;\r\n    aspect-ratio: 1/1;\r\n    display: flex;\r\n    justify-content: center;\r\n    color:#fff !important;\r\n    align-items: center;\r\n}\r\n\r\n.main-item {\r\n    width: 2rem;\r\n    aspect-ratio: 1/1;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 0px 14px;\r\n    border-right: 1px solid #DEE2E6;\r\n    align-items: center;\r\n}\r\n\r\n@mixin circle {\r\n    border: 1px solid #d1d1d1;\r\n    border-radius: 50%;\r\n    aspect-ratio: 1/1;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n// .main-item:hover {\r\n//     @include circle\r\n// }\r\n\r\n.next-prev:hover {\r\n    width: 2rem;\r\n    aspect-ratio: 1/1;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 0px 17px;\r\n    border-right: 1px solid #DEE2E6;\r\n    align-items: center;\r\n}\r\n\r\n.next-prev {\r\n    width: 2rem;\r\n    width: 2rem;\r\n    aspect-ratio: 1/1;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 0px 17px;\r\n    border-right: 1px solid #DEE2E6;\r\n    align-items: center;\r\n}\r\n\r\n.msg {\r\n    position: fixed;\r\n    bottom: 0.8rem;\r\n    left: 1dvw;\r\n    color: gray;\r\n}\r\n\r\n.mainSelected {\r\n    background-color: #0364B4;\r\n    border-radius: 2px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
